//utils
import { buildComputedForm } from "@u/methods";
import { ValidObj } from "@u/model";
import { rex_value } from "@u/regex";
function formObj(_this) {
  return {
    email: {
      ...new ValidObj(""),
      key: "email",
      label: "帳號",
      placeholder: () => _this.$tp("please.enter", { label: "Email" }),
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) }
      ]
    }
  }
}
export default {
  data() {
    return {
      form: formObj(this)
    }
  },
  computed: {
    ...buildComputedForm(formObj())
  }
}